import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  type?: string;
  image?: string;
  url?: string;
  jsonLd?: Record<string, any>;
  noindex?: boolean;
}

const SEO: React.FC<SEOProps> = ({
  title = 'The Most Useless Website - Fascinating Facts & Time Wasters',
  description = 'Discover mind-blowing useless facts, weird animal trivia, and fascinating time-wasters. Your daily dose of entertaining knowledge that you never knew you needed!',
  type = 'website',
  image = 'https://themostuselesswebsite.com/og-image.jpg',
  url = typeof window !== 'undefined' ? window.location.href : '',
  jsonLd,
  noindex = false
}) => {
  const baseSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'The Most Useless Website',
    description,
    url: 'https://themostuselesswebsite.com',
    potentialAction: {
      '@type': 'SearchAction',
      'target': 'https://themostuselesswebsite.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string'
    }
  };

  const schema = jsonLd || baseSchema;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Robots Control */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="The Most Useless Website" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="The Most Useless Website" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SEO